import { useState } from "react";
import asset1 from "../../assets/images/asset1.png";
import { FaSquarePhone } from "react-icons/fa6";
import "./nc_hrt.scss";
import {
  postPrescriptionTemplate,
  postPatientReport,
  fetchPatientDetailsUuid,
  coupleIdChecker,
  postAppointment,
} from "../../Redux/Thunk/Actions";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import headerimage from "../../assets/images/ascas.svg";
import Headers from "../../Components/Header/Headers";
import Footer from "../../Components/footer/Footer";
import { PrescriptionFooter } from "../../Components/Prescription Footer/PrescriptionFooter";

export default function NcHrt(props) {
  const [show, setshow] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [patientOne_UUId, setPatientOne_UUId] = useState("");
  const patientId = useSelector((state) => state.counter.patientid);
  const [values, setValues] = useState({});
  const [valueChange, setvalueChange] = useState({});
  const [appointmentData, setAppointmentData] = useState({
    p_uhid: "",
    name: "",
    date: "",
    time: "",
    status: "Not Visited",
    notes: "",
    patient_id: "",
  });

  const [rows, setRows] = useState([
    { date: "", cycleDay: "", right: "", left: "", et: "", drugsAdvice: "" },
  ]);

  const handleAddRow = () => {
    setRows([
      ...rows,
      { date: "", cycleDay: "", right: "", left: "", et: "", drugsAdvice: "" },
    ]);
  };

  const handleRemoveRow = (index) => {
    const newRows = rows.filter((row, i) => i !== index);
    setRows(newRows);
  };

  const handleChange = (index, e) => {
    const { name, value } = e.target;
    const newRows = [...rows];
    newRows[index][name] = value;
    setRows(newRows);
  };

  const renderInput = (name) => (
    <>
      <input
        name={name}
        className={`createTime ${show ? "hide" : "show"}`}
        style={{ border: "1px solid black !important" }}
        onChange={handleChangeid}
      />
      <span className={`input ${!show ? "hide" : "show"}`}>
        &nbsp;{valueChange[name]}
      </span>
    </>
  );

  const handleChangeid = (e) => {
    var text = e.target.value;

    if (e.target.name === "patientId1") {
      if (/^(ASCAS|VDASCAS)\d+$/i.test((e.target.value || "").trim())) {
        const fetchData = async () => {
          const payload = {
            p_uhid: e.target.value,
          };
          props.loaderchange("true");
          const addPatient = fetchPatientDetailsUuid(payload);
          const response = await dispatch(addPatient);
          if (response.payload?.status?.code === 200) {
            const data = response.payload.data.data[0];
            const namePat =
              data?.titles + " " + data?.first_name + " " + data?.last_name;
            if (e.target.name === "patientId1") {
              setPatientOne_UUId(data?.id);
              setvalueChange({
                ...valueChange,
                patientName1: namePat,
                age1: data?.age,
                gender1: data?.gender,
                patientId1: text,
              });
            }
            props.loaderchange("false");
          } else {
            props.loaderchange("false");
            props.popupalert("true");
            props.popuptext("Network went wrong, Please try after some time.");
            setTimeout(() => {
              props.popupalert("false");
            }, 2000);
          }
          return;
        };

        fetchData();
      } else {
        if (e.target.name === "patientId1") {
          setvalueChange({
            ...valueChange,
            patientId1: e.target.value,
          });
        }
      }
    } else {
      setvalueChange({ ...valueChange, [e.target.name]: e.target.value });
      if (e.target.name === "nextappointment") {
        const dateTime = e.target.value.split("T");
        setAppointmentData({
          ...appointmentData,
          date: dateTime[0],
          time: dateTime[1],
          p_uhid: props.patientsData.p_uhid,
          name: `${props.patientsData.titles} ${props.patientsData.first_name} ${props.patientsData.last_name}`,
          status: "Not Visited",
          notes: "Booking Visit",
          patient_id: patientId,
        });
      }
    }
  };

  const renderReportfield = (name, value, options = {}) => {
    const { styleSec = {}, styleLabel = {}, styleSpan = {} } = options;

    return (
      <>
        <section
          style={{ ...styleSec, margin: "0 10px 10px 10px", display: "flex" }}
        >
          <label
            style={{
              ...styleLabel,
              fontWeight: "600",
              marginRight: "5px",
              width: "max-content",
            }}
          >
            {name}
          </label>
          <span style={styleSpan}>{value}</span>
        </section>
      </>
    );
  };

  const renderTableTD = (value) => {
    return (
      <td style={{ border: "1px solid black", textAlign: "center" }}>
        {value}
      </td>
    );
  };
  const renderTableTH = (value) => {
    return (
      <th style={{ border: "1px solid black", textAlign: "center" }}>
        {value}
      </th>
    );
  };

  const handlesubmit = () => {
    props.loaderchange("true");

    try {
      if (
        props.patientsData.id !== "" &&
        props.patientsData.p_uhid !== "" &&
        /^(ASCAS|VDASCAS)\d+$/i.test((props.patientsData.p_uhid || '').trim())
      ) {
        setshow(true);
        setTimeout(async () => {
          const htmlPayload =
            document.getElementById("ncHrtReportWrap").innerHTML;

          const payload = {
            payload: {
              prescription_template: htmlPayload,
              patient_id: patientId,
              description: "",
              template_type: "NC HRT",
            },
          };

          const createNewAppointment = async () => {
            console.log(appointmentData);
            await dispatch(postAppointment(appointmentData));
          };
          createNewAppointment();

          props.loaderchange(true);
          const patentDetails = postPrescriptionTemplate(payload);
          const response = await dispatch(patentDetails);
          if (response?.payload?.status?.code === 200) {
            props.loaderchange(false);
            navigate("/PatientView");
            Swal.fire({
              title: "Successful.",
              text: "Record added successful.",
              icon: "success",
              showConfirmButton: false,
              timer: 1500,
            });
            props.loaderchange("false");
          } else {
            props.loaderchange("false");
            props.popupalert("true");
            props.popuptext("Network went wrong, Please try after some time.");
            // props.popuptext(response?.status?.message);
            setTimeout(() => {
              props.popupalert("false");
            }, 2000);
          }
        }, 3000);
      } else {
        Swal.fire({
          title: "Error.",
          text: "Please enter valid patient id.",
          icon: "error",
          showConfirmButton: false,
          timer: 1500,
        });
      }
    } catch (error) {
      console.error("An error occurred:", error);
    }
  };

  return (
    <div id="NcHrt" style={{ backgroundColor: "white" }}>
      <div className="NcHrt">
        <div style={{ width: "100%", display: "block" }} id="patientInfo1">
          {/* <div style={{ width: "100%" }}>
            <img
              className="header_image"
              // src={"https://s3.amazonaws.com/likodi.com/ascslogo.png"}
              src={headerimage}
              style={{
                // width: "100%", height: "25vh", maxHeight: show ? "100px" : "400px"

                width: "100%",
                margin: "0 auto",
              }}
            ></img>
          </div> */}

          {/* //* header part* */}

          <div
            style={{
              paddingTop: "10px",
              marginBottom: "5px",
              borderBottom: "1px solid black",
              display: "flex",
              justifyContent: "space-between",
              width: "100%",
              height: "200px",
            }}
          >
            <section
              style={{
                marginLeft: "10px",
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
              }}
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  fontSize: "14px",
                  margin: "0px",
                  gap: "5px",
                }}
              >
                <p
                  style={{ margin: "0px", fontWeight: "200", fontSize: "13px" }}
                >
                  Physician specializing in :
                </p>
                <p
                  style={{ margin: "0px", fontWeight: "600", fontSize: "14px" }}
                >
                  Fertility Obstetrics Laparoscopy <br />
                  Gynecology <br />
                  Ultrasound/3D scan <br />
                </p>
              </div>
              <div>
                <p
                  style={{
                    fontWeight: "600",
                    margin: "0px",
                    display: "flex",
                    alignItems: "end",
                    fontSize: "16px",
                  }}
                >
                  Dr. Aishwarya Parthasarathy
                </p>
              </div>
            </section>
            <section
              style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-around",
                alignItems: "center",
              }}
            >
              <img src={asset1} style={{ maxWidth: "200px" }} />
              <p
                style={{
                  textAlign: "center",
                  fontSize: "13px",
                  fontWeight: "200",
                }}
              >
                24, Chowdry Nagar Main Rd, opp, Vasanthi Dental Hospital,
                Majestic Colony, <br />
                Valasasaravakkam, Chennai, Tamil Nadu 600087
              </p>
            </section>
            <section
              style={{
                marginRight: "10px",
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
              }}
            >
              <div
                style={{
                  fontSize: "14px",
                  textAlign: "right",
                  display: "flex",
                  flexDirection: "column",
                  gap: "5px",
                }}
              >
                <p
                  style={{ margin: "0px", fontWeight: "200", fontSize: "13px" }}
                >
                  For Booking Appointment
                </p>
                <p
                  style={{ fontWeight: "600", margin: "0px", fontSize: "14px" }}
                >
                  <FaSquarePhone
                    style={{
                      display: "inline",
                      marginTop: "-2px",
                      background: "transparent",
                    }}
                    size={18}
                  />{" "}
                  +91 93425 21779
                </p>
                <p
                  style={{ fontWeight: "600", margin: "0px", fontSize: "14px" }}
                >
                  044 4793 9484
                </p>
              </div>
              <div>
                <p
                  style={{
                    fontWeight: "600",
                    textAlign: "right",
                    margin: "0px",
                    fontSize: "16px",
                  }}
                >
                  Dr. Ashwin
                </p>
              </div>
            </section>
          </div>

          {/* <div
            className="NcHrtPatientToAgeContainer"
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
              justifyContent: "center",
              gap: "3px",
              // backgroundColor: "#f7f7f7 ",
              borderRadius: "6px",
              padding: "16px 8px 16px 8px",
              gap: "3px",
            }}
          >
            <div style={{ display: "flex", gap: "16px", alignItems: "center" }}>
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "125px 16px 250px",
                  alignItems: "center ",
                }}
              >
                <span style={{ fontWeight: 600 }}>Patient ID</span>
                <span style={{ fontWeight: 600 }}>: </span>
                <input
                  type="text"
                  className={`createTime ${show ? "hide" : "show"}`}
                  value={valueChange.patientId1}
                  onChange={(e) => handleChangeid(e)}
                  name="patientId1"
                  style={{
                    border: "1px solid red",
                    outline: "none",
                    padding: "10px",
                  }}
                />
                <span className={`input ${!show ? "hide" : "show"}`}>
                  &nbsp;{valueChange.patientId1}
                </span>
              </div>
            </div>

            <div
              style={{
                display: "grid",
                gridTemplateColumns: "125px 16px 250px",
                alignItems: "center ",
              }}
            >
              <span style={{ fontWeight: 600 }}>Patient Name</span>
              <span style={{ fontWeight: 600 }}>: </span>
              <input
                type="text"
                className={`createTime ${show ? "hide" : "show"}`}
                onChange={(e) => handleChangeid(e)}
                value={valueChange.patientName1}
                name="patientName1"
                style={{
                  border: "1px solid #ddd",
                  outline: "none",
                  padding: "10px",
                  color: "#000",
                }}
              />
              <span
                className={`input ${!show ? "hide" : "show"}`}
                style={{ width: "100%" }}
              >
                &nbsp;{valueChange.patientName1}
              </span>
            </div>

            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "16px",
              }}
            >
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "125px 16px 250px",
                  alignItems: "center ",
                }}
              >
                <span style={{ fontWeight: 600 }}>Gender</span>
                <span style={{ fontWeight: 600 }}>: </span>
                <select
                  className={`createTime ${show ? "hide" : "show"}`}
                  onChange={(e) => handleChangeid(e)}
                  value={valueChange.gender1}
                  name="gender1"
                  style={{
                    border: "1px solid #ddd",
                    outline: "none",
                    padding: "10px",
                    backgroundColor: "white",
                  }}
                >
                  <option value="" disabled selected>
                    Select Gender
                  </option>
                  <option value="Male">Male</option>
                  <option value="Female">Female</option>
                  <option value="Others">Others</option>
                  <option value="Decline to State">Decline to State</option>
                </select>
                <span className={`input ${!show ? "hide" : "show"}`}>
                  &nbsp;{valueChange.gender1}
                </span>
              </div>
            </div>

            <div
              style={{
                display: "grid",
                gridTemplateColumns: "125px 16px 250px",
                alignItems: "center ",
              }}
            >
              <span style={{ fontWeight: 600 }}>Age</span>
              <span style={{ fontWeight: 600 }}>: </span>
              <input
                type="text"
                className={`createTime ${show ? "hide" : "show"}`}
                onChange={(e) => handleChangeid(e)}
                value={valueChange.age1}
                name="age1"
                style={{
                  border: "1px solid #ddd",
                  outline: "none",
                  padding: "10px",
                }}
              />
              <span className={`input ${!show ? "hide" : "show"}`}>
                &nbsp;{valueChange.age1}
              </span>
            </div>
          </div> */}
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
              justifyContent: "center",
              gap: "3px",
              // backgroundColor: "#f7f7f7 ",
              borderRadius: "6px",
              padding: "16px 8px 16px 8px",
              gap: "3px",
            }}
          >
            <div style={{ display: "flex", gap: "16px", alignItems: "center" }}>
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "125px 16px 250px",
                  alignItems: "center ",
                }}
              >
                <span style={{ fontWeight: 600 }}>Patient ID</span>
                <span style={{ fontWeight: 600 }}>: </span>
                <input
                  type="text"
                  className={`createTime ${show ? "hide" : "show"}`}
                  value={props.patientsData.p_uhid}
                  onChange={(e) => handleChangeid(e)}
                  name="patientId"
                  style={{
                    border: "1px solid #ddd",
                    outline: "none",
                    padding: "10px",
                  }}
                />
                <span className={`input ${!show ? "hide" : "show"}`}>
                  &nbsp;{props.patientsData.p_uhid}
                </span>
              </div>
            </div>

            <div
              style={{
                display: "grid",
                gridTemplateColumns: "125px 16px 250px",
                alignItems: "center ",
              }}
            >
              <span style={{ fontWeight: 600 }}>Patient Name</span>
              <span style={{ fontWeight: 600 }}>: </span>
              <input
                type="text"
                className={`createTime ${show ? "hide" : "show"}`}
                onChange={(e) => handleChangeid(e)}
                value={`${props.patientsData.titles} ${props.patientsData.first_name} ${props.patientsData.last_name}`}
                name="patientName"
                style={{
                  border: "1px solid #ddd",
                  outline: "none",
                  padding: "10px",
                  color: "#000",
                }}
              />
              <span
                className={`input ${!show ? "hide" : "show"}`}
                style={{ width: "100%" }}
              >
                &nbsp;
                {`${props.patientsData.titles} ${props.patientsData.first_name} ${props.patientsData.last_name}`}
              </span>
            </div>

            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "16px",
              }}
            >
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "125px 16px 250px",
                  alignItems: "center ",
                }}
              >
                <span style={{ fontWeight: 600 }}>Gender</span>
                <span style={{ fontWeight: 600 }}>: </span>
                <select
                  className={`createTime ${show ? "hide" : "show"}`}
                  onChange={(e) => handleChangeid(e)}
                  value={props.patientsData.gender}
                  name="gender"
                  style={{
                    border: "1px solid #ddd",
                    outline: "none",
                    padding: "10px",
                    backgroundColor: "white",
                  }}
                >
                  <option value={props.patientsData.gender} selected>
                    {props.patientsData.gender}
                  </option>
                  <option value="Male">Male</option>
                  <option value="Female">Female</option>
                  <option value="Others">Others</option>
                  <option value="Decline to State">Decline to State</option>
                </select>
                <span className={`input ${!show ? "hide" : "show"}`}>
                  &nbsp;{props.patientsData.gender}
                </span>
              </div>
            </div>

            <div
              style={{
                display: "grid",
                gridTemplateColumns: "125px 16px 250px",
                alignItems: "center ",
              }}
            >
              <span style={{ fontWeight: 600 }}>Age</span>
              <span style={{ fontWeight: 600 }}>: </span>
              <input
                type="text"
                className={`createTime ${show ? "hide" : "show"}`}
                onChange={(e) => handleChangeid(e)}
                value={props.patientsData.age}
                name="age1"
                style={{
                  border: "1px solid #ddd",
                  outline: "none",
                  padding: "10px",
                }}
              />
              <span className={`input ${!show ? "hide" : "show"}`}>
                &nbsp;{props.patientsData.age}
              </span>
            </div>
          </div>
        </div>
        <div className="detail">
          <p>
            Planned for ET :{/* - CYCLE NUMBER */}
            <input
              type="text"
              className={`createTime ${show ? "hide" : "show"} embryo`}
              onChange={(e) => handleChangeid(e)}
              value={valueChange.plannedForEt}
              name="plannedForEt"
              style={{
                border: "1px solid black",
                outline: "none",
                padding: "10px",
              }}
            />
            <span className={`input ${!show ? "hide" : "show"}`}>
              &nbsp;{valueChange.plannedForEt}
            </span>
          </p>
          <p>
            Embryos available:{" "}
            <input
              type="text"
              className={`createTime ${show ? "hide" : "show"} embryo`}
              onChange={(e) => handleChangeid(e)}
              value={valueChange.embryosAvailable}
              name="embryosAvailable"
              style={{
                border: "1px solid black",
                outline: "none",
                padding: "10px",
              }}
            />
            <span className={`input ${!show ? "hide" : "show"}`}>
              &nbsp;{valueChange.embryosAvailable}
            </span>
          </p>
          <p>
            Trial Cannulation:{" "}
            <select name="trialCannulation" onChange={handleChangeid}>
              <option value="" disabled selected>
                Please Select
              </option>

              <option value="Easy">Easy</option>
              <option value="Difficult">Difficult</option>
            </select>
            <span className={`input ${!show ? "hide" : "show"}`}>
              &nbsp;{valueChange.trialCannulation}
            </span>
          </p>
          <p>
            Shaving done:{" "}
            <select name="shavingDone" onChange={handleChangeid}>
              <option value="" disabled selected>
                Please Select
              </option>

              <option value="Yes">Yes</option>
              <option value="no">no</option>
            </select>
            <span className={`input ${!show ? "hide" : "show"}`}>
              &nbsp;{valueChange.shavingDone}
            </span>
          </p>
          <p className={"planSelect"}>
            Plan:{" "}
            <select
              name="plan"
              onChange={handleChangeid}
              style={{ marginLeft: "10px" }}
            >
              <option value="" disabled selected>
                Please Select
              </option>

              <option value="Regular HRT">Regular HRT</option>
              <option value="Tamoxifen HRT">Tamoxifen HRT</option>
              <option value="NC HRT">NC HRT</option>
            </select>
            <span className={`input ${!show ? "hide" : "show"}`}>
              &nbsp;{valueChange.plan}
            </span>
          </p>
        </div>
        <table className="table_1" border="1px" cellSpacing="0px">
          <tbody>
            <tr>
              <th>TSH</th>
              <th>Prolactin</th>
              <th>FBS/HBA1c</th>
              <th>E2</th>
            </tr>
            <tr>
              <td>{renderInput("TSH")}</td>
              <td>{renderInput("Prolactin")}</td>
              <td>{renderInput("FBS_HBA1c")}</td>
              <td>{renderInput("E2")}</td>
            </tr>
          </tbody>
        </table>
        <br />
        <table className="table_1" border="1px" cellSpacing="0px">
          <tbody>
            <tr>
              <th>ET</th>
              <th>RIGHT OV</th>
              <th>LEFT OV</th>
            </tr>
            <tr>
              <td>{renderInput("et")}</td>
              <td>{renderInput("rightOv")}</td>
              <td>{renderInput("leftOv")}</td>
            </tr>
          </tbody>
        </table>
        <br />
        <div className="detail">
          <p>Medications</p>
        </div>
        <table className="table_1" border="1px" cellSpacing="0px">
          <tbody>
            <tr>
              <th>Medications</th>
              <th>Dosage</th>
              <th>Frequency</th>
              {/* <th>Timing</th> */}
              <th>Route</th>
              <th>Days</th>
            </tr>
            <tr>
              <td>T Letrosoul / LETROZ</td>
              <td>{renderInput("Letrosoul_Dosage")}</td>
              <td>{renderInput("Letrosoul_Frequency")}</td>
              {/* <td>{renderInput("Letrosoul_Timing")}</td> */}
              <td>{renderInput("Letrosoul_Route")}</td>
              <td>{renderInput("Letrosoul_Days")}</td>
            </tr>
            <tr>
              <td>C. FOLVISTA</td>
              <td>{renderInput("Folvista_Dosage")}</td>
              <td>{renderInput("Folvista_Frequency")}</td>
              {/* <td>{renderInput("Folvista_Timing")}</td> */}
              <td>{renderInput("Folvista_Route")}</td>
              <td>{renderInput("Folvista_Days")}</td>
            </tr>
            <tr>
              <td>Tab. Ecosprin 75/150</td>
              <td>{renderInput("Ecospirin_Dosage")}</td>
              <td>{renderInput("Ecospirin_Frequency")}</td>
              {/* <td>{renderInput("Ecospirin_Timing")}</td> */}
              <td>{renderInput("Ecospirin_Route")}</td>
              <td>{renderInput("Ecospirin_Days")}</td>
            </tr>
            <tr>
              <td>T. Pentoxia ER</td>
              <td>{renderInput("PentoxiaER_Dosage")}</td>
              <td>{renderInput("PentoxiaER_Frequency")}</td>
              {/* <td>{renderInput("PentoxiaER_Timing")}</td> */}
              <td>{renderInput("PentoxiaER_Route")}</td>
              <td>{renderInput("PentoxiaER_Days")}</td>
            </tr>
            <tr>
              <td>T. Tamoxifen</td>
              <td>{renderInput("Tamoxifen_Dosage")}</td>
              <td>{renderInput("Tamoxifen_Frequency")}</td>
              {/* <td>{renderInput("Tamoxifen_Timing")}</td> */}
              <td>{renderInput("Tamoxifen_Route")}</td>
              <td>{renderInput("Tamoxifen_Days")}</td>
            </tr>
            <tr>
              <td>T. Sildenafil</td>
              <td>{renderInput("Sildenafil_Dosage")}</td>
              <td>{renderInput("Sildenafil_Frequency")}</td>
              {/* <td>{renderInput("Sildenafil_Timing")}</td> */}
              <td>{renderInput("Sildenafil_Route")}</td>
              <td>{renderInput("Sildenafil_Days")}</td>
            </tr>
            <tr>
              <td>TAB. THYRONORM</td>
              <td>{renderInput("Thyronorm_Dosage")}</td>
              <td>{renderInput("Thyronorm_Frequency")}</td>
              {/* <td>{renderInput("Thyronorm_Timing")}</td> */}
              <td>{renderInput("Thyronorm_Route")}</td>
              <td>{renderInput("Thyronorm_Days")}</td>
            </tr>
            <tr>
              <td>TAB. GLYCOMET SR</td>
              <td>{renderInput("GlycometSR_Dosage")}</td>
              <td>{renderInput("GlycometSR_Frequency")}</td>
              {/* <td>{renderInput("GlycometSR_Timing")}</td> */}
              <td>{renderInput("GlycometSR_Route")}</td>
              <td>{renderInput("GlycometSR_Days")}</td>
            </tr>
            <tr>
              <td>TAB. HCQ</td>
              <td>{renderInput("HCQ_Dosage")}</td>
              <td>{renderInput("HCQ_Frequency")}</td>
              {/* <td>{renderInput("HCQ_Timing")}</td> */}
              <td>{renderInput("HCQ_Route")}</td>
              <td>{renderInput("HCQ_Days")}</td>
            </tr>
            <tr>
              <td>TAB. WYSOLONE</td>
              <td>{renderInput("Wysolone_Dosage")}</td>
              <td>{renderInput("Wysolone_Frequency")}</td>
              {/* <td>{renderInput("Wysolone_Timing")}</td> */}
              <td>{renderInput("Wysolone_Route")}</td>
              <td>{renderInput("Wysolone_Days")}</td>
            </tr>
          </tbody>
        </table>

        <table
          className="table_1"
          border="1px"
          cellSpacing="0px"
          style={{ marginTop: "50px" }}
        >
          <thead>
            <tr>
              <th>Date</th>
              <th>Cycle Day</th>
              <th>Rt.Ovary</th>
              <th>Lt.Ovary</th>
              <th>ET(mm)</th>
              <th>Drugs / Advice</th>
              <th>ACTIONS</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((row, index) => (
              <tr key={index}>
                <td>
                  <input
                    type="date"
                    className={`createTime ${show ? "hide" : "show"}`}
                    name="date"
                    value={row.date}
                    onChange={(e) => handleChange(index, e)}
                  />
                  <span className={`input ${!show ? "hide" : "show"}`}>
                    &nbsp;{row.date}
                  </span>
                </td>
                <td>
                  <input
                    className={`createTime ${show ? "hide" : "show"}`}
                    name="cycleDay"
                    value={row.cycleDay}
                    onChange={(e) => handleChange(index, e)}
                  />
                  <span className={`input ${!show ? "hide" : "show"}`}>
                    &nbsp;{row.cycleDay}
                  </span>
                </td>
                <td>
                  <input
                    className={`createTime ${show ? "hide" : "show"}`}
                    name="right"
                    value={row.right}
                    onChange={(e) => handleChange(index, e)}
                  />
                  <span className={`input ${!show ? "hide" : "show"}`}>
                    &nbsp;{row.right}
                  </span>
                </td>
                <td>
                  <input
                    className={`createTime ${show ? "hide" : "show"}`}
                    name="left"
                    value={row.left}
                    onChange={(e) => handleChange(index, e)}
                  />
                  <span className={`input ${!show ? "hide" : "show"}`}>
                    &nbsp;{row.left}
                  </span>
                </td>
                <td>
                  <input
                    className={`createTime ${show ? "hide" : "show"}`}
                    name="et"
                    value={row.et}
                    onChange={(e) => handleChange(index, e)}
                  />
                  <span className={`input ${!show ? "hide" : "show"}`}>
                    &nbsp;{row.et}
                  </span>
                </td>
                <td>
                  <input
                    className={`createTime ${show ? "hide" : "show"}`}
                    name="drugsAdvice"
                    value={row.drugsAdvice}
                    onChange={(e) => handleChange(index, e)}
                  />
                  <span className={`input ${!show ? "hide" : "show"}`}>
                    &nbsp;{row.drugsAdvice}
                  </span>
                </td>
                <td>
                  {index == 0 && (
                    <button
                      className={`${show ? "hide" : "show"}`}
                      onClick={(e) => handleAddRow(index)}
                    >
                      +
                    </button>
                  )}
                  {index > 0 && (
                    <button
                      className={`${show ? "hide" : "show"}`}
                      onClick={() => handleRemoveRow(index)}
                    >
                      -
                    </button>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        <p style={{ fontWeight: "600" }}>
          NEXT APPOINTMENT -{" "}
          <input
            name="nextappointment"
            onChange={handleChangeid}
            type="datetime-local"
            // type="date"
          />
        </p>
        <div className={`Footer ${show ? "hide" : "show"}`}>
          <button onClick={handlesubmit} className="Button_Create">
            Add Report
          </button>
        </div>
        <br />
      </div>
      <div id="ncHrtReport">
        <div id="ncHrtReportWrap">
          <Headers />
          <p class="Dani"></p>
          <div
            className="patient"
            style={{
              border: "1px solid black",
              borderRadius: "10px",
              marginBottom: "10px",
            }}
          >
            <div
              className="nameToAgeContainer"
              style={{ display: "flex", marginBottom: "10px" }}
            >
              {renderReportfield(
                "Patient Name :",
                `${props.patientsData.titles} ${props.patientsData.first_name} ${props.patientsData.last_name}`
              )}
              {renderReportfield("Patient ID :", props.patientsData.p_uhid)}
              {renderReportfield("Gender :", props.patientsData.gender)}
              {renderReportfield("Age :", props.patientsData.age)}
            </div>
          </div>
          <div style={{ display: "flex", marginBottom: "10px" }}>
            {renderReportfield("Planned for ET :", valueChange.plannedForEt)}
            {renderReportfield(
              "Embryos Available :",
              valueChange.embryosAvailable
            )}
            {renderReportfield(
              "Trial Cannulation :",
              valueChange.trialCannulation
            )}
            {renderReportfield("Shaving done :", valueChange.shavingDone)}
            {renderReportfield("Plan : ", valueChange.plan)}
          </div>
          <div style={{ marginTop: "10px" }}>
            <table
              style={{
                marginBottom: "10px",
                border: "1px solid black",
                width: "800px",
                textAlign: "center",
              }}
            >
              <thead>
                <tr>
                  {["TSH", "Prolactin", "FBS/HBA1c", "E2"].map((ele) =>
                    renderTableTH(ele)
                  )}
                </tr>
              </thead>
              <tbody>
                <tr>
                  {["TSH", "Prolactin", "FBS_HBA1c", "E2"].map((ele) =>
                    renderTableTD(valueChange[ele])
                  )}
                </tr>
              </tbody>
            </table>
          </div>
          <div style={{ marginTop: "10px" }}>
            <table
              style={{
                marginBottom: "10px",
                border: "1px solid black",
                width: "800px",
                textAlign: "center",
              }}
            >
              <thead>
                <tr>
                  {["ET", "Right OV", "Left OV"].map((ele) =>
                    renderTableTH(ele)
                  )}
                </tr>
              </thead>
              <tbody>
                <tr>
                  {["et", "rightOv", "leftOv"].map((ele) =>
                    renderTableTD(valueChange[ele])
                  )}
                </tr>
              </tbody>
            </table>
          </div>
          <div style={{ display: "flex", marginTop: "10px" }}>
            <h5 style={{ fontWeight: 600, marginRight: "5px" }}>
              Medications :-
            </h5>
          </div>
          <div style={{ marginTop: "10px" }}>
            <table
              style={{
                marginBottom: "10px",
                border: "1px solid black",
                width: "800px",
                textAlign: "center",
              }}
            >
              <thead>
                <tr>
                  {["Medications", "Dosage", "Frequency", "Route", "Days"].map(
                    (ele) => renderTableTH(ele)
                  )}
                </tr>
              </thead>
              <tbody>
                {[
                  "T Letrosoul / LETROZ||Letrosoul_",
                  "C. FOLVISTA||Folvista_",
                  "Tab. Ecosprin 75/150||Ecospirin_",
                  "T. Pentoxia ER||PentoxiaER_",
                  "T. Tamoxifen||Tamoxifen_",
                  "T. Sildenafil||Sildenafil_",
                  "TAB. THYRONORM||Thyronorm_",
                  "TAB. GLYCOMET SR||GlycometSR_",
                  "TAB. HCQ||HCQ_",
                  "TAB. WYSOLONE||Wysolone_",
                ].map((ele) => {
                  let columns = ["Dosage", "Frequency", "Route", "Days"];
                  return (
                    <tr>
                      {renderTableTD(ele.split("||")[0])}
                      {columns.map((innerEle) => (
                        <>
                          {renderTableTD(
                            valueChange[`${ele.split("||")[1]}${innerEle}`]
                          )}
                        </>
                      ))}
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
          <div style={{ marginTop: "10px" }}>
            <table
              style={{
                marginBottom: "10px",
                border: "1px solid black",
                width: "800px",
                textAlign: "center",
              }}
            >
              <thead>
                <tr>
                  {[
                    "Date	",
                    "Cycle Day	",
                    "Rt.Ovary",
                    "Lt.Ovary",
                    "ET(mm)",
                    "Drugs / Advice",
                  ].map((ele) => renderTableTH(ele))}
                </tr>
              </thead>
              <tbody>
                {rows.map((ele) => (
                  <tr>
                    {renderTableTD(ele.date)}
                    {renderTableTD(ele.cycleDay)}
                    {renderTableTD(ele.right)}
                    {renderTableTD(ele.left)}
                    {renderTableTD(ele.et)}
                    {renderTableTD(ele.drugsAdvice)}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <div style={{ marginTop: "10px" }}>
            {renderReportfield(
              "Next Appointment : ",
              appointmentData.date?.split("-").reverse().join("-")
            )}
          </div>
          <p class="Dani"></p>
        <PrescriptionFooter/>
        </div>
      </div>
    </div>
  );
}
